export enum KnmResultDecisionSubjectTypesEnum {
  CONTROLLING_SUBJECT = 'CONTROLLING_SUBJECT',
  FOUNDER = 'FOUNDER',
}
